<template>
    <div class="art-box">
        <div class="art-box-bg">
            <a href="#add"><el-button>立即咨询</el-button></a>
            <div class="art-box-common art-box-infor">
                <h3>专业介绍</h3>
                <p>美术高考是我国高考的一种考试方式，一般由各省自主进行，考生需完成当年高考报名和专业考试报名手续，具体考试时间由各地自行决定，一般在统一高考时间前的半年内进行。任何人只要能参加普通高考，就能参加美术高考。 <br>美术生亦称美术特长生，以美术为专长，参加高考的考生，拥有美术方面的特长，在高考之前要参加欲报考美术生高校的美术加试，加试成绩加上高考成绩之和，高校方进行择优录取。</p>
            </div>
        </div> 
        <div class="art-box-work art-box-common">
            <h3>就业方向</h3>
            <el-row type="flex" class="art-box-work-list">
                <el-col v-for="(item,index) in workList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="art-box-tiao art-box-common art-box-common1">
            <h3>报考条件</h3>
            <h4>对专业感兴趣，具备较高理论修养和艺术鉴赏能力，还要坚持学习</h4>
            <el-row class="art-box-tiao-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in tiaoList" :key="index">
                    <img :src="item.src">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="art-box-test art-box-common art-box-common1">
            <h3>考试内容</h3>
            <h4>素描、写生、色彩、速写、创作设计和面试等</h4>
            <el-row class="art-box-test-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in testList" :key="index">
                    <img :src="item.src" alt="">
                    <h5 v-html="item.desc"></h5>
                </el-col>
            </el-row>
        </div>
        <div class="art-box-subject art-box-common art-box-common1">
            <h3>学习科目</h3>
            <el-row class="art-box-subject-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in subjectList" :key="index">
                    <img :src="item.src" alt="">
                    <h5>{{item.desc}}</h5>
                </el-col>
            </el-row>
        </div>
        <div class="art-box-tips art-box-common art-box-common1">
            <h3>艺考流程</h3>
            <p>美术生考试时间：</p>   
            <el-row class="art-box-tips-content" type="flex" justify="space-between">
                <el-col class="art-box-tips-item1">
                    <h4>上午</h4>
                    <div>水粉</div>
                    <img src="../../assets/images/art-time-icon1.png">
                </el-col>
                <el-col class="art-box-tips-item2">
                    <h4>下午</h4>
                    <div>素描、速写</div>
                    <img src="../../assets/images/art-time-icon2.png">
                </el-col>
            </el-row>
        </div>
        <div class="art-box-school art-box-common art-box-common1">
            <h3>推荐院校</h3>
            <el-row class="art-box-school-content" type="flex" justify="space-between">
                <el-col v-for="(item,index) in schoolList" :key="index">
                    <el-row type="flex">
                        <el-col :span="6">
                            <img :src="item.src" alt="">
                        </el-col>
                        <el-col :span="18">
                            <div>{{item.desc}}</div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <div class="art-box-order" id="add">
            <div class="art-box-order-content art-box-common art-box-common1">
                <h3>提交咨询表</h3>
                <h4>填写信息后，可以查询更多艺考信息</h4>
                <el-row>
                    <el-form :inline="true" :model="formInline" class="order-form-inline" :rules="rules" ref="formInline">
                        <el-form-item label="姓名：" prop="username">
                            <el-input v-model="formInline.username" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话：" prop="phone">
                            <el-input v-model="formInline.phone" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="专业：" prop="major">
                            <el-input v-model="formInline.major" placeholder="请输入专业"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="addSubscribeHandler" v-click-with-auth-login>提交</el-button>
                        </el-form-item>
                        </el-form>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import { addSubscribe } from '@/api/user'
export default {
    data() {
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入姓名"));
            } else {
                callback();
            }
        };
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入电话"));
                } else {
                if ((/^1[34578]\d{9}$/.test(value))) {
                    callback();
                } else {
                    callback(new Error("请输入正确的电话"));
                }
            }
        };
        const validateMajor = (rule, value, callback) => {
            if (!value) {
                callback(new Error("请输入专业"));
            } else {
                callback();
            }
        };
        return {
            workList:[
                {src:require('../../assets/images/art-work-icon1.png'),desc:'电视台'},
                {src:require('../../assets/images/art-work-icon3.png'),desc:'广告公司'},
                {src:require('../../assets/images/art-work-icon4.png'),desc:'游戏公司'},
                {src:require('../../assets/images/art-work-icon5.png'),desc:'影视特技公司'},
                {src:require('../../assets/images/art-work-icon6.png'),desc:'多媒体设计公司'},
                {src:require('../../assets/images/art-work-icon7.png'),desc:'动漫设计制作公司'},
                {src:require('../../assets/images/art-work-icon8.png'),desc:'珠宝设计公司'},
                {src:require('../../assets/images/art-work-icon9.png'),desc:'出版社'},
                {src:require('../../assets/images/art-work-icon10.png'),desc:'设计事务所'},
                {src:require('../../assets/images/art-work-icon11.png'),desc:'文化馆'},
                {src:require('../../assets/images/art-work-icon12.png'),desc:'研究'},
                {src:require('../../assets/images/art-work-icon13.png'),desc:'绘画'},
                {src:require('../../assets/images/art-work-icon14.png'),desc:'教学'},
                {src:require('../../assets/images/art-work-icon15.png'),desc:'管理工作'},
                {src:require('../../assets/images/art-work-icon16.png'),desc:'装饰公司'},
            ],
            tiaoList:[
                {src:require('../../assets/images/art-tiao-icon1.png'),desc:'具有高中毕业文化程度，身体健康'},
                {src:require('../../assets/images/art-tiao-icon2.png'),desc:'无色盲色弱'},
            ],
            testList:[
                {src:require('../../assets/images/art-test-icon1.png'),desc:'速写'},
                {src:require('../../assets/images/art-test-icon2.png'),desc:'色彩<br>（静物，头像，风景）'},
                {src:require('../../assets/images/art-test-icon3.png'),desc:'设计基础'},
                {src:require('../../assets/images/art-test-icon4.png'),desc:'素描'},
                {src:require('../../assets/images/art-test-icon5.png'),desc:'装饰画'},
            ],
            subjectList:[
                {src:require('../../assets/images/art-subject-icon1.png'),desc:'素猫'},
                {src:require('../../assets/images/art-subject-icon2.png'),desc:'色彩'},
                {src:require('../../assets/images/art-subject-icon3.png'),desc:'速写'},
                {src:require('../../assets/images/art-subject-icon4.png'),desc:'创作'},
                {src:require('../../assets/images/art-subject-icon5.png'),desc:'设计'},
                {src:require('../../assets/images/art-subject-icon6.png'),desc:'校考试题'},
                {src:require('../../assets/images/art-subject-icon7.png'),desc:'作品赏析'},
                {src:require('../../assets/images/art-subject-icon8.png'),desc:'美术常识'},
            ],
            schoolList:[
                {src:require('../../assets/images/art-school-icon1.png'),desc:'中央美术学院'},
                {src:require('../../assets/images/art-school-icon2.png'),desc:'中国美术学院'},
                {src:require('../../assets/images/art-school-icon3.png'),desc:'清华大学美术学院'},
                {src:require('../../assets/images/art-school-icon4.png'),desc:'四川美术学院'},
                {src:require('../../assets/images/art-school-icon5.png'),desc:'鲁迅美术学院'},
                {src:require('../../assets/images/art-school-icon6.png'),desc:'广州美术学院'},
                {src:require('../../assets/images/art-school-icon7.png'),desc:'天津美术学院'},
                {src:require('../../assets/images/art-school-icon8.png'),desc:'西安美术学院'},
                {src:require('../../assets/images/art-school-icon9.png'),desc:'湖北美术学院'},
                {src:require('../../assets/images/art-school-icon10.png'),desc:'山东工艺美术学院'},
            ],
            formInline: {
                username: '',
                phone: '',
                major: '',
                type: '11'
            },
            rules: {
                username: [
                    { trigger: 'blur', validator: validateUsername },
                ],
                phone: [
                    { trigger: 'blur', validator: validatePhone },
                ],
                major: [
                    { trigger: 'blur', validator: validateMajor },
                ],
            }
        };
    },
    methods: {
        addSubscribeHandler() {
            let that = this;
            this.$refs.formInline.validate((valid) => {
                if(valid) {
                    addSubscribe(that.formInline).then(res => {
                        this.$message({
                            message: '提交成功',
                            type: 'success'
                        });
                    })
                }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
$font-family: 'MicrosoftYaHei';
$width: 1200px;
$margin: 0 auto;
.art-box-common {
    padding-top: 62px;
    box-sizing: border-box;
    h3 {
        font-size: 36px;
        font-family: $font-family;
        font-weight: 700;
        text-align: center;
        color: #332e2c;
        line-height: 47px;
        letter-spacing: 3.6px;
        margin: 0;
    }
}
.art-box-common1 {
    >h4 {
        font-size: 18px;
        font-family: $font-family;
        font-weight: 400;
        text-align: center;
        color: rgba(255,255,255,0.60);
        line-height: 24px;
        margin: 27px 0 62px 0;
    }
}
.art-box-bg {
    background: url('../../assets/images/art-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 644px;
    button {
        width: 136px;
        height: 50px;
        background: rgba(255,255,255,0.20)!important;
        border: 1px solid #ffffff!important;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 400;
        color: #ffffff;
        position: relative;
        left: calc(50% - 600px);
        top: 320px;
    }
    button:hover {
        background: rgba(255,255,255,0)!important;
    }
}
.art-box-infor {
    width: $width;
    margin: $margin;
    height: 323px;
    background: rgba(255,255,255,0.90);
    border-radius: 20px;
    box-shadow: 0px 4px 20px 0px rgba(143,43,0,0.12), 0px 1.5px 0px 0px rgba(255,255,255,0.56) inset; 
    backdrop-filter: blur(4px);
    padding: 44px 58px;
    margin-top: 400px;
    p {
        font-size: 20px;
        font-family: $font-family;
        font-weight: 400;
        color: #2c3331;
        line-height: 38px;
        margin-top: 36px;
    }
}
.art-box-work {
    padding-top: 190px;
    height: 1049px;
    background: #f5f7fa;
    box-sizing: border-box;
    .art-box-work-list {
        width: $width;
        margin: $margin;
        // align-content:space-between;
        // flex-flow: row wrap;
        flex-wrap: wrap;
        margin-top: 69px;
    }
    .el-col:not(:nth-child(5n)) {
        margin-right: 100px;
    }
    .el-col {
        width: 160px;
        text-align: center;
        h5 {
            margin-top: 16px;
            font-size: 20px;
            font-family: $font-family;
            font-weight: 400;
            text-align: center;
            color: #2c3331;
            line-height: 26px;
            margin-bottom: 32px;
        }
    }
}
.art-box-tiao {
    height: 635px;
    background: url('../../assets/images/broadcast-tiao-bg.jpg') no-repeat center;
    background-size: cover;
    position: relative;
    padding-top: 52px;
    h3 {
        color: #ffffff;
    }
    .art-box-tiao-content {
        width: $width;
        margin: 0 auto;
        flex-wrap: wrap;
        margin-top: 4px;
        .el-col {
            width: 572px;
            height: 347px;
            position: relative;
            margin-bottom: 40px;
        }
        h5 {
            // padding: 0 30px;
            margin: 0;
            font-size: 18px;
            position: absolute;
            font-family: $font-family;
            font-weight: 400;
            text-align: center;
            color: #ffffff;
            line-height: 60px;
            text-align: center;
            height: 60px;
            background: rgba(228,123,43,0.70);
            border-radius: 0px 0px 20px 20px;
            bottom: 0px;
            width: 100%;
        }
    }
}
.art-box-test {
    background: url('../../assets/images/common-test.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    height: 534px;
    h4 {
        color: #999999;
    }
    .art-box-test-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        margin-top: 62px;
        .el-col {
            width: 224px;
            h5 {
                font-size: 22px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #332e2c;
                margin: 20px 0 0 0;
                line-height: 29px;
            }
        }
    }
}
.art-box-subject {
    width: 100%;
    height: 549px;
    background: #e47b2b;
    h3 {
        color: #fff;
    }
    .art-box-subject-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        margin-top: 56px;
        .el-col {
            width: 25%;
            text-align: center;
            h5 {
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                text-align: center;
                color: #ffffff;
                line-height: 26px;
                margin: 20px 0 60px 0;
            }
        }
    }
}
.art-box-tips {
    width: 100%;
    height: 409px;
    background: #ffff;
    p {
        font-size: 24px;
        font-family: $font-family;
        color: #332e2c;
        line-height: 31px;
        width: $width;
        margin: $margin;
        margin-top: 42px;
        font-weight: 700;
    }
    .art-box-tips-content {
        width: $width;
        margin: $margin;
        margin-top: 24px;
        .el-col {
            width: 580px;
            height: 131px;
            border-radius: 8px;
            padding: 24px;
            box-sizing: border-box; 
            position: relative;
            img {
                position: absolute;
                right: 9px;
                bottom: 0;
            }
            h4 {
                font-size: 28px;
                font-family: $font-family;
                font-weight: 700;
                color: #2c3331;
                margin: 0;
                margin-bottom: 2px;
                line-height: 37px;
            }
            div {
                margin-top: 20px;
                font-size: 18px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                line-height: 26px;
                position: relative;
                line-height: 28px;
            }
        }
        .art-box-tips-item1 {
            background: #ecf4ff;
            border: 1px solid #b3d3ff;
        }
        .art-box-tips-item2 {
            background: #fff4eb;
            border: 1px solid #ffdbbd;
        }
    }
}
.art-box-school {
    height: 443px;
    background: url('../../assets/images/director-school-bg.jpg') no-repeat center;
    background-size: cover;
    width: 100%;
    h3 {
        color: #fff;
    }
    .art-box-school-content {
        width: $width;
        margin: $margin;
        flex-wrap: wrap;
        .el-col-24 {
            padding:16px 12px;
            width: 220px;
            height: 88px;
            background: #ffffff;
            border-radius: 8px;
            margin-top: 48px;
            .el-row {
                justify-content: center;
                align-items: center;
            }
            .el-col-18 {
                display: inline-block;
                font-size: 20px;
                font-family: $font-family;
                font-weight: 400;
                color: #2c3331;
                padding-left: 18px;
            }
        }
    }
}
.art-box-order {
    background: url('../../assets/images/common-bg.png') no-repeat;
    background-size: cover;
    background-color: #e47b2b;
    height: 359px;
    margin-bottom: -56px;
    h3 {
        color: #fff;
    }
    h4 {
        margin-bottom: 55px;
    }
    .art-box-order-content {
        width: $width;
        margin: $margin;
        .order-form-inline {
            margin-top: 0;
        }
        span {
            display: inline-block;
        }
        img {
            position: absolute;
            top:0;
            left: 0;
        }
        .art-box-order-title {
            font-size: 36px;
            font-family: 'zihun443hao';
            color: #ffffff;
        }
        .art-box-order-desc {
            font-size: 18px;
            font-weight: 500;
            color: #ffffff;
            margin-left: 24px;
        }
    }
}
</style>